import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {TableRequest} from "../../../model/api/table-request";
import {TableButtonConfig} from "../../../model/api/table-button-config";
import {ReportTask} from "../../../model/archive/report-task";
import {ReportTaskService} from "../../../services/archive/report-task.service";
import {ReportTaskLoadRequest} from "../../../model/archive/report-task-load-request";

@Component({
  templateUrl: './report-tasks.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportTasksComponent extends CcBaseComponent {

  transPartKey: string = 'report-tasks';

  tableConfig: TableColumnConfig[] = [];

  headerButtonConfig: TableButtonConfig[] = [];

  contextMenuConfig: MenuItem[] = [];
  formRecord: ReportTask;
  selectedRecords: ReportTask[];
  records: ReportTask[];
  recordsChange = new EventEmitter<ReportTask[]>();

  totalRecords: number = 0;

  tableLoading: boolean = true;

  tableCurrentRequest: ReportTaskLoadRequest;
  tableCurrentRequestChange = new EventEmitter<TableRequest>();

  origins: string[];

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              protected reportTaskService: ReportTaskService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

    this.origins = [ReportTask.Origin.WEB_REPORT, ReportTask.Origin.WEB_REPORT_FORM, ReportTask.Origin.SYSTEM_REPORT, ReportTask.Origin.SYSTEM];
  }

}
